import axios from "@shared/axios";
import Broadcast from "@shared-models/communication/broadcast.model";
import BroadcastFeedInterface from "@shared-interfaces/communication/broadcast.feed.interface";

const EMPTY_FEED: BroadcastFeedInterface = { broadcasts: [], hasMore: false, nextCursor: null };

/** Une page du fil. `before` = le `nextCursor` de la page précédente. */
async function getBroadcastFeed(before?: string | null): Promise<BroadcastFeedInterface>
{
	const response = await axios.get("/communication/broadcasts", {
		params: before ? { before } : {}
	});

	return response?.data as BroadcastFeedInterface ?? EMPTY_FEED;
}

async function getUnreadBroadcastsCount(): Promise<number>
{
	const response = await axios.get("/communication/broadcasts/unread-count");

	return response?.data ?? 0;
}

async function markBroadcastsAsRead(): Promise<void>
{
	await axios.put("/communication/broadcasts/read");
}

/** Un message seul, pour rafraîchir sa bulle sans toucher au reste du fil. */
async function getBroadcast(broadcastId: string): Promise<Broadcast>
{
	const response = await axios.get(`/communication/broadcasts/${ broadcastId }`);

	return response?.data as Broadcast ?? null;
}

/**
 * Pose, change ou retire sa réaction — l'API tranche selon ce qui est déjà posé, reposer le
 * même emoji le retirant.
 *
 * Elle rend le message à jour : le fil remplace la bulle concernée sans recharger la page.
 */
async function updateBroadcastReaction(broadcastId: string, reaction: string | null): Promise<Broadcast>
{
	const response = await axios.put(
		`/communication/broadcasts/${ broadcastId }/reaction`,
		{ "reaction": reaction }
	);

	return response?.data as Broadcast ?? null;
}

export {
	getBroadcastFeed,
	getBroadcast,
	getUnreadBroadcastsCount,
	markBroadcastsAsRead,
	updateBroadcastReaction
};
